import decoder from 'jwt-decode';

export const decodeTokenJsonUser = (token) => {
    const decodedToken = decoder(token);
    const json = {};
    for (let prop in decodedToken) {
        const splitProp = prop.split('/');
        Object.defineProperty(json, splitProp[splitProp.length - 1], {
            writable: true,
            enumerable: false,
            configurable: true,
            value: decodedToken[prop]
        });
    }

    return json;
}